import React from 'react'
import { useTheme } from '../contexts/ThemeContext';

const Footer = () => {
    const { isDark } = useTheme();

    return (
        <footer className={`w-full py-6 px-6 border-t transition-colors ${
            isDark
                ? 'bg-dark-bg-secondary border-dark-border text-dark-text-secondary'
                : 'bg-light-bg-secondary border-light-border text-light-text-secondary'
        }`}>
            <div className="max-w-7xl mx-auto text-center">
                <p className="font-mono text-xs md:text-sm">
                    <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                        //
                    </span>
                    {' '}© {new Date().getFullYear()} Designed and developed by{' '}
                    <span className={`font-semibold ${
                        isDark ? 'text-dark-brand-primary' : 'text-light-brand-primary'
                    }`}>
                        Zunayed Fahim
                    </span>
                </p>
            </div>
        </footer>
    )
}

export default Footer
